import React from 'react';
import Types from 'prop-types';
import { FormattedMessage } from 'react-intl';
var Badge = function Badge(_ref) {
  var translationKey = _ref.translationKey,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("span", {
    className: "badge badge-success ".concat(className)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: translationKey
  }));
};
Badge.defaultProps = {
  className: ''
};
export default Badge;